import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { bindActionCreators } from 'redux'
import { useParams } from 'react-router-dom'

import {
  buildExtensionsUrl,
  fromExtensionsTabIdToType
} from '../util/extensions/extensions.helpers'
import Extensions from '../components/extensions/Extensions'
import { isDashboardReady } from '../util/dashboard.helpers'
import { REQUEST_FEATURE_URL } from '../constants/navigation'
import {
  getUserSurveys,
  submitUserSurvey,
  updateUserSurvey
} from '../store/actions/survey'
import { openExternalUrl } from '../util/app/app.helpers'
import { buildCalendarUrl } from '../util/externalResource.helpers'
import { changeToolsFilterState } from '../store/actions/extensions'
import { EXTENSIONS_TAB_TYPE } from '../constants/extensions'

const ExtensionsContainer = ({
  history,
  getUserSurveys,
  submitUserSurvey,
  updateUserSurvey,
  userId,
  surveyProfile,
  ...restProps
}) => {
  const { t } = useTranslation()

  useEffect(() => {
    getUserSurveys()
  }, [])

  const { selectedTab } = useParams()

  const setSelectedTab = (selectedTab) => {
    history.push(buildExtensionsUrl(selectedTab))
  }

  useEffect(() => {
    if (!selectedTab) {
      setSelectedTab(EXTENSIONS_TAB_TYPE.THIRD_PARTY_TOOLS)
    }
  }, [selectedTab])

  const handleChangeTab = (_, selectedTabId) => {
    const newTab = fromExtensionsTabIdToType(selectedTabId)
    if (selectedTab !== newTab) {
      setSelectedTab(newTab)
    }
  }

  const handleClickSuggestFavorite = () => {
    history.push(REQUEST_FEATURE_URL)
  }

  const handleLikeUnlikeBrand = (surveyId, questionId) => {
    const userSurvey = surveyProfile.userSurveys?.[surveyId]
    const userSurveyId = userSurvey?.id
    if (userSurveyId) {
      updateUserSurvey(
        surveyId,
        userSurveyId,
        questionId,
        !userSurvey.response?.[questionId]?.liked
      )
    } else {
      submitUserSurvey(surveyId, questionId, true)
    }
  }

  const handleBookCall = () => {
    openExternalUrl(buildCalendarUrl(userId))
  }

  return (
    <Extensions
      t={t}
      selectedTab={selectedTab}
      onChangeTab={handleChangeTab}
      onClickSuggestFavorite={handleClickSuggestFavorite}
      onLikeUnlikeBrand={handleLikeUnlikeBrand}
      onClickBookCall={handleBookCall}
      surveyProfile={surveyProfile}
      {...restProps}
    />
  )
}

const mapStateToProps = ({
  dashboardReducer,
  tokensReducer,
  mainReducer,
  surveyReducer,
  accountReducer,
  extensionsReducer
}) => {
  const { dashboardSetupProfile } = dashboardReducer
  const { tokenProfile } = tokensReducer
  const { billingProfile } = mainReducer
  const { surveyProfile } = surveyReducer
  const { userId } = accountReducer.accountProfile
  const { extensionsProfile } = extensionsReducer

  return {
    isDashboardSetupReady: isDashboardReady(
      dashboardSetupProfile.dashboardSetupState
    ),
    tokenProfile,
    billingProfile,
    surveyProfile,
    userId,
    extensionsProfile
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getUserSurveys,
      changeToolsFilterState,
      submitUserSurvey,
      updateUserSurvey
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(ExtensionsContainer)
